module.exports = __webpack_public_path__ + "static/media/matlab.cf286322.png";